import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { EtapaPostDTO, EtapaRequestDTO, schemaEtapaViewDTO } from './schemas'
import { PaginacionRequest, schemaEntityListWithPagination } from 'src/types'
import { z } from 'src/lib'

const getEndpoint = (url = '') => `workflow/etapas${url}`

export const HttpEtapasABM = {
    getEtapa: (idEtapa: number) => {
        return HttpAxiosRequest.get(getEndpoint(`/${idEtapa}`)).then(res => {
            const parsed = schemaEtapaViewDTO.safeParse(res)

            if (!parsed.success) {
                console.log(parsed.error)

                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },

    getEtapas: (paginacion: PaginacionRequest, filter: EtapaRequestDTO) => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(), {
            ...paginacion,
            ...filter
        }).then(res => {
            const parsed = schemaEntityListWithPagination(schemaEtapaViewDTO).safeParse(res)

            if (!parsed.success) {
                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },

    getEtapasPorSistema: (codSistema: number) => {
        return HttpAxiosRequest.get(`workflow/${codSistema}/etapas`).then(res => {
            const parsed = z.array(schemaEtapaViewDTO).safeParse(res)

            if (!parsed.success) {
                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },

    // TODO: en el constructor de la api hay que rejectear cuando tiene Error = true !!! (o devolver error en vez de 200)
    postEtapa: (etapa: EtapaPostDTO) => {
        return new Promise<any>((resolve, reject) => {
            HttpAxiosRequest.post(getEndpoint(), etapa)
                .then(res => {
                    if (res?.tieneError) {
                        reject(res?.descripcionError)
                    } else {
                        resolve(res)
                    }
                })
                .catch(reject)
        })
    },

    putEtapa: (idEtapa: number, etapa: EtapaPostDTO) => {
        return HttpAxiosRequest.put(getEndpoint(`/${idEtapa}`), etapa)
    },

    getPermisosEtapa: (idEtapa: number) => {
        return HttpAxiosRequest.get(getEndpoint(`/${idEtapa}/permisos`)).then(res => {
            const parsed = z.array(schemaEtapaViewDTO).safeParse(res)

            if (!parsed.success) {
                return Promise.reject()
            }

            return Promise.resolve(parsed.data)
        })
    },

    deleteEtapa: (idEtapa: number) => {
        return HttpAxiosRequest.delete(getEndpoint(`/${idEtapa}`))
    }
}
